export function selectTask(state, taskId) {
    return state?.notifications?.notifications?.[taskId] || {};
}
